import React, { Component } from 'react';
import { NextButton } from '../components/NextButton';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
}

export class SwitcherTopupYes extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Yes!</span> You can release equity out of your home</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <p>for home improvements, and in some instances to consolidate loans, pay for education expenses</p>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.props.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow showDisclaimer />
                    </div>
                </div>
            </header>
        );
    }
}
